import Form from './Form';

export default Form;



// WEBPACK FOOTER //
// ./src/shared/components/Form/index.js